"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
require("@/components/common/avatar/avatar");
require("@/components/common/flex/flex");
require("@/components/common/text");
/* 행 높이 안에서 라벨과 설명 두 줄이 차지하는 크기. 두 줄의 line-height 합이 행 높이를 넘지 않는다. */
const LABEL_TEXT_SIZE = { small: '14', medium: '14', large: '18' };
const DESCRIPTION_TEXT_SIZE = { medium: '12', large: '14' };
/**
 * leading(아바타·아이콘) + content(title/description) + trailing 한 줄을 구성하는 표현 전용 primitive.
 * 상호작용(role, hover 등)은 포함하지 않는다. 메뉴 의미가 필요하면 mm-menu-item-action을 쓴다.
 * 두 줄이 되는 행은 medium부터다. small은 한 줄만 그리고 description을 받아도 무시한다.
 */
let ListItem = class ListItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'small';
        this.label = '';
        this.description = '';
        this.emoji = '';
        this.avatarSrc = '';
        this.avatarVariant = 'primary';
        this.avatarShape = 'square';
        this.hasTrailing = false;
    }
    willUpdate(changed) {
        if (!changed.has('description') && !changed.has('size'))
            return;
        this.toggleAttribute('has-description', this.size !== 'small' && !!this.description);
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderLeading()}
      <div class="content">${this.renderLabel()} ${this.renderDescription()}</div>
      ${this.renderTrailing()}
    `;
    }
    renderTrailing() {
        if (!this.hasTrailing) {
            return (0, lit_1.html) `
        <slot name="trailing" hidden @slotchange=${this.handleTrailingSlotChange}></slot>
      `;
        }
        return (0, lit_1.html) `
      <span slot="trailing">
        <slot name="trailing" @slotchange=${this.handleTrailingSlotChange}></slot>
      </span>
    `;
    }
    renderLeading() {
        if (!this.hasLeading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <span slot="leading">${this.renderLeadingContent()}</span>
    `;
    }
    renderLeadingContent() {
        return (0, lit_1.html) `
      <mm-avatar
        size=${this.avatarSize}
        variant=${this.avatarVariant}
        shape=${this.avatarShape}
        icon=${(0, if_defined_js_1.ifDefined)(this.icon)}
        src=${(0, if_defined_js_1.ifDefined)(this.avatarSrc || undefined)}
      >
        ${this.renderEmoji()}
      </mm-avatar>
    `;
    }
    renderEmoji() {
        if (!this.emoji)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <span class="emoji" aria-hidden="true">${this.emoji}</span>
    `;
    }
    renderLabel() {
        if (!this.label)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size=${LABEL_TEXT_SIZE[this.size]}>${this.label}</mm-text>
    `;
    }
    renderDescription() {
        const { size } = this;
        if (size === 'small' || !this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size=${DESCRIPTION_TEXT_SIZE[size]} color="light">${this.description}</mm-text>
    `;
    }
    get avatarSize() {
        if (this.size === 'small')
            return '32';
        return this.size === 'medium' ? '40' : '80';
    }
    get hasLeading() {
        return !!(this.icon || this.avatarSrc || this.emoji);
    }
    handleTrailingSlotChange(event) {
        const slot = event.target;
        this.hasTrailing = this.hasAssignedContent(slot);
    }
    hasAssignedContent(slot) {
        return slot
            .assignedNodes({ flatten: true })
            .some(node => (node.nodeType === Node.TEXT_NODE && node.textContent?.trim() !== '') ||
            node.nodeType === Node.ELEMENT_NODE);
    }
};
ListItem.styles = [list_item_styles_1.listItemStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ListItem.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ListItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ListItem.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ListItem.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ListItem.prototype, "emoji", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], ListItem.prototype, "avatarSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-variant' })
], ListItem.prototype, "avatarVariant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-shape' })
], ListItem.prototype, "avatarShape", void 0);
__decorate([
    (0, decorators_js_1.state)()
], ListItem.prototype, "hasTrailing", void 0);
ListItem = __decorate([
    (0, decorators_js_1.customElement)('mm-list-item')
], ListItem);
exports.ListItem = ListItem;
//# sourceMappingURL=data:application/json;base64,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